import { useState, useEffect } from 'react';

export default function LoadingScreen() {
  const [isLoading, setIsLoading] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFadeOut(true);
      setTimeout(() => setIsLoading(false), 500);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  if (!isLoading) return null;

  return (
    <div
      className={`fixed inset-0 z-[100] bg-primary flex flex-col items-center justify-center transition-opacity duration-500 ${fadeOut ? 'opacity-0 pointer-events-none' : 'opacity-100'}`}
    >
      <img
        src="https://storage.readdy-site.link/project_files/82b66968-cb22-42ee-9075-ece8509330fe/d7ebf39b-4e71-401b-976c-6b7206641a00_2522-removebg-preview.png?v=064e295420a590555ff0a1679155b011"
        alt="Confident Auriga"
        className="h-14 md:h-16 w-auto max-w-[200px] md:max-w-[260px] object-contain brightness-0 invert"
      />
      <p className="font-body text-xs md:text-sm text-white/60 mt-3 tracking-[0.3em] uppercase">Premium Plotted Development</p>
      <div className="mt-8 w-32 h-[2px] bg-white/10 rounded-full overflow-hidden">
        <div className="h-full bg-gold animate-[loadingSlide_1.5s_ease-in-out_infinite]" style={{
          animation: 'loadingSlide 1.5s ease-in-out infinite',
        }} />
      </div>
    </div>
  );
}